import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = '/recaudacion/leyendas-bancarias/';

/**
 * GET Leyendas Bancarias
 * @returns {Promise<Array<object>>}
 */
export const getLeyendasBancarias = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Leyenda Bancaria
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getLeyendaBancaria = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Leyenda Bancaria
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postLeyendaBancaria = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Leyenda Bancaria
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchLeyendaBancaria = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Leyenda Bancaria
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteLeyendaBancaria = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
